(ns app.domain.user.licence
  (:require [clojure.set :as set]))

(def all-keys #{:user-licence/number
                :user-licence/subtype})

(defn config->licence-config
  [config licence]
  (get-in config [:user-licence-config (:user-licence/type licence)]))

(defn drop-extra-keys
  "Remove licence attributes which are not required by the config"
  [licence config]
  (let [licence-config (config->licence-config config licence)
        keys-to-keep   (cond-> #{}
                         (:number? licence-config)
                         (conj :user-licence/number)

                         (:subtypes licence-config)
                         (conj :user-licence/subtype))]
    (apply dissoc licence (set/difference all-keys keys-to-keep))))

(defn- number-ok?
  [[licence config]]
  (if (:number? config)
    (-> licence :user-licence/number count pos?)
    true))

(defn- subtype-ok?
  [[licence config]]
  (if-let [subtypes (-> config :subtypes seq)]
    (contains? (set subtypes) (:user-licence/subtype licence))
    true))

(def is-valid? (every-pred number-ok?
                           subtype-ok?))

(defn licence-valid?
  "Return true if the given licence satisfies all requirements
  for the licence type in the given config."
  [licence config]
  (let [licence-config (config->licence-config config licence)]
    (-> (and licence-config
             (is-valid? [licence licence-config]))
        boolean)))

(defn licence-unknown?
  "Return true if the given licence does not match any known licence configuration"
  [licence config]
  (nil? (config->licence-config config licence)))
